/* eslint tailwindcss/no-custom-classname: off */
import { useRouter } from 'next/router'
import { SubmitButton } from '@/components/button/SubmitButton'

export const BooksellerRegist: React.FC = () => {
  const router = useRouter()
  return (
    <div className="p-4 m-5 my-0 mx-auto sm:w-[716px]">
      <div className="p-5 border border-orange-400">
        <div className="alert-for-not-user-title">
          <div>
            <img src={`${process.env.IMG_SERVER}/common/logo.png`} alt="" />
          </div>
          <span>
            新刊から名著まで
            <wbr />
            要約は2,900冊以上！
            <br />
            まずは<span className="text-orange-400">無料で会員登録</span>
          </span>
        </div>
        <div className="pt-5 pc">
          「本の要約サイト flier(フライヤー)」は、多忙なビジネスパーソンが
          <span className="text-orange-400">本の内容を効率的につかむ</span>
          ことで、ビジネスに役立つ知識・教養を身につけ、
          <span className="text-orange-400">スキルアップ</span>
          に繋げることができます。具体的には、新規事業のアイデア、営業訪問時のトークネタ、ビジネストレンドや業界情報の把握、リーダーシップ・コーチングなどです。
        </div>

        <div className="pt-5 center">
          <SubmitButton
            text="会員登録"
            bgColor="#E9544E"
            onClick={() => router.push('/welcome?af_via=campaigns')}
          />
        </div>
      </div>
    </div>
  )
}
